<template>
    <node-view-wrapper
        as="span"
        class="tiptap-chip"
        :class="{
            'tiptap-chip--editable': isGrowthInvest() && editor.options.editable
        }"
    >
        <span class="tiptap-chip__wrap">
            <app-chip
                :text="chipText"
                :type="chipType"
                :prefix="prefix"
                :icon="resolvedIcon"
                :x-small="size === 'x-small'"
                :small="size === 'small'"
                :large="size === 'large'"
                :x-large="size === 'x-large'"
                :bold="bold"
                :solid="solid"
                :dark="dark"
            />
            <span v-if="isGrowthInvest() && editor.options.editable" class="tiptap-chip__options">
                <tiptap-chip-options :options="options" :update-attributes="updateAttributes" />
            </span>
        </span>
    </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';

import { getIcon } from '@utils/image';

export default {
    name: 'TiptapChip',
    components: {
        NodeViewWrapper,
        TiptapChipOptions: () => import('@plugins/tiptap/components/TiptapChipOptions.vue')
    },
    props: {
        ...nodeViewProps
    },
    computed: {
        chipText() {
            return this.node.attrs.text || 'Chip';
        },
        chipType() {
            return this.node.attrs.type ?? 'primary';
        },
        prefix() {
            return this.node.attrs.prefix || null;
        },
        icon() {
            return this.node.attrs.icon || null;
        },
        resolvedIcon() {
            const icon = this.node.attrs.icon;
            if (!icon) return null;
            return getIcon(icon);
        },
        size() {
            return this.node.attrs.size ?? 'large';
        },
        bold() {
            return this.node.attrs.bold || false;
        },
        solid() {
            return this.node.attrs.solid || false;
        },
        dark() {
            return this.node.attrs.dark || false;
        },
        options() {
            return {
                text: this.chipText,
                type: this.chipType,
                prefix: this.prefix,
                icon: this.icon,
                size: this.size,
                bold: this.bold,
                solid: this.solid,
                dark: this.dark
            };
        }
    }
};
</script>

<style lang="scss">
.tiptap-chip {
    display: inline;
    position: relative;

    &--editable {
        .tiptap-chip__wrap {
            padding-right: 1.4rem;
        }
    }

    &__wrap {
        display: inline;
        vertical-align: baseline;
    }

    &__options {
        position: absolute;
        top: 50%;
        right: 0rem;
        transform: translateY(-50%);
        width: 1.4rem;
    }
}
</style>
